module.exports = __webpack_public_path__ + "img/feature_video.0797f66d.png";